import { render, staticRenderFns } from "./SubmissionReviewForm.vue?vue&type=template&id=37a85a61&scoped=true&"
import script from "./SubmissionReviewForm.vue?vue&type=script&lang=js&"
export * from "./SubmissionReviewForm.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionReviewForm.vue?vue&type=style&index=0&id=37a85a61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a85a61",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VForm,VIcon})
